<script setup lang="ts">
const { userBankAccounts } = useUserData();

type Props = {
  pickable?: boolean;
};

const { pickable = false } = defineProps<Props>();

const selectedBankAccountId = defineModel<number>('modelValue', {
  required: false,
});
</script>

<template>
  <BaseFormRadio
    v-model="selectedBankAccountId"
    :class="$style.bankAccountsList"
    :options="userBankAccounts"
    value-key="id"
    v-bind="{ pickable }"
  >
    <template #item="{ option }">
      <UserAccountBankAccountsListItem
        v-model="selectedBankAccountId"
        :bank-account="option"
        :class="$style.bankAccountsListItem"
      />
    </template>
  </BaseFormRadio>
</template>

<style module lang="postcss">
.bankAccountsList {
  @apply flex flex-wrap gap-0;

  & label {
    @apply border-t border-texts/5 border-solid;

    &:last-of-type {
      @apply border-b;
    }
  }
}
</style>
